import { ProgresNBack } from "../../styles/styles";
import "./style.css";
import Loading from "../../loading";

function CardsDash(props) {
	return (
		<div className="">
			{props.loading ? (
				<Loading />
			) : (
				<div className="row ">
					<div className="col-sm-6 col-xl-6 col-lg-6  card-container">
						<div className="card l-bg-green2">
							<div className="card-statistic-3 p-2">
								<div className="card-icon card-icon-large">
									<i className="fas fa-dollar-sign"></i>
								</div>
							</div>
							<div className="row p-3">
								<div className="col-7">
									<h5>Receitas</h5>
									<h3 className="d-flex align-items-center mb-0">
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitas
										)}
									</h3>
									<span className="d-block mt-4">Atrasados</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitasAtrasadas
										)}
									</b>
								</div>
								<div className="col-5">
									<span className="d-block">Recebido</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitasPagas
										)}
									</b>
									<ProgresNBack percents={props.receitasPercPagas} width={120} color="white">
										<div>
											<div className="progressListBackground">
												<div className="progressList"></div>
											</div>
										</div>
										<div className="perc">
											<small className="">{props.receitasPercPagas}%</small>
										</div>
									</ProgresNBack>
									<span className="d-block mt-4">À Receber</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitasAtrasadas + props.receitasAReceber
										)}
									</b>
									<ProgresNBack percents={props.receitasPercAReceber} width={120} color="white">
										<div>
											<div className="progressListBackground">
												<div className="progressList"></div>
											</div>
										</div>
										<div className="perc">
											<small className="">{props.receitasPercAReceber}%</small>
										</div>
									</ProgresNBack>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-6 col-xl-6 col-lg-6  card-container">
						<div className="card l-bg-red-dark">
							<div className="card-statistic-3 p-2">
								<div className="card-icon card-icon-large">
									<i className="fas fa-dollar-sign"></i>
								</div>
							</div>
							<div className="row p-3">
								<div className="col-7">
									<h5>Despesas</h5>
									<h3 className="d-flex align-items-center mb-0">
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.despesas
										)}
									</h3>
									<span className="d-block mt-4">Atrasados</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.despesasAtrasadas
										)}
									</b>
								</div>
								<div className="col-5">
									<span className="d-block">Pago</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.despesasPagas
										)}
									</b>
									<ProgresNBack percents={props.despesasPercPagas} width={120}>
										<div>
											<div className="progressListBackground">
												<div className="progressList"></div>
											</div>
										</div>
										<div className="perc">
											<small className="">{props.despesasPercPagas}%</small>
										</div>
									</ProgresNBack>
									<span className="d-block mt-4">À Pagar</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.despesasAtrasadas + props.despesasAReceber
										)}
									</b>
									<ProgresNBack percents={props.despesasPercAReceber} width={120} color="white">
										<div>
											<div className="progressListBackground">
												<div className="progressList"></div>
											</div>
										</div>
										<div className="perc">
											<small className="">{props.despesasPercAReceber}%</small>
										</div>
									</ProgresNBack>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-6 col-xl-6 col-lg-6  card-container">
						<div className="card l-bg-cyan">
							<div className="card-statistic-3 p-2">
								<div className="card-icon card-icon-large">
									<i className="fas fa-dollar-sign"></i>
								</div>
							</div>
							<div className="row p-3">
								<div className="col-7">
									<h5>Receitas - Despesas</h5>
									<h3 className="d-flex align-items-center mb-0">
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitas - props.despesas
										)}
									</h3>
									<span className="d-block mt-4">Atrasados</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitasAtrasadas - props.despesasAtrasadas
										)}
									</b>
								</div>
								<div className="col-5">
									<span className="d-block">Recebido - Pago</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitasPagas - props.despesasPagas
										)}
									</b>

									<span className="d-block mt-4">À Receber - À Receber</span>
									<b>
										{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
											props.receitasAtrasadas + props.receitasAReceber
										)}
									</b>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default CardsDash;

// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-cherry">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-shopping-cart"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">New Orders</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">3,243</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						12.5% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>

// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-green-dark2">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-users"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">Customers</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">15.07k</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						9.2% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-green" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>
// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-green-dark3">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-ticket-alt"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">Despesas Pendentes</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">$11.61k</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						2.5% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>
// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-cherry">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-shopping-cart"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">New Orders</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">3,243</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						12.5% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>
// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-teste">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-dollar-sign"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">Revenue Today</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">$11.61k</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						2.5% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>

// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-teste">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-dollar-sign"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">Revenue Today</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">$11.61k</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						2.5% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>
// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-teste">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-dollar-sign"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">Revenue Today</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">$11.61k</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						2.5% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>
// <div class="col-xl-3 col-lg-6">
// 	<div class="card l-bg-teste">
// 		<div class="card-statistic-3 p-4">
// 			<div class="card-icon card-icon-large">
// 				<i class="fas fa-dollar-sign"></i>
// 			</div>
// 			<div class="mb-4">
// 				<h5 class="card-title mb-0">Revenue Today</h5>
// 			</div>
// 			<div class="row align-items-center mb-2 d-flex">
// 				<div class="col-8">
// 					<h2 class="d-flex align-items-center mb-0">$11.61k</h2>
// 				</div>
// 				<div class="col-4 text-right">
// 					<span>
// 						2.5% <i class="fa fa-arrow-up"></i>
// 					</span>
// 				</div>
// 			</div>
// 			<div class="progress mt-1 " data-height="8">
// 				<div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
// 			</div>
// 		</div>
// 	</div>
// </div>
